import { withInstall } from '@vuesax-plus/utils'
import Navbar from './src/navbar.vue'

export const VsNavbar = withInstall(Navbar)
export default VsNavbar

export * from './src/navbar'
